import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaPlus(complexDenominator, c1, c2, r1, sImaginary) {
  var result = Complex.createComplex(1, sImaginary * r1 * (c1 + c2)).divide(complexDenominator);
  return result;
}

export function computeComplexFF() {
  var result = Complex.createComplex(0, 0);
  return result;
}
